import { render, staticRenderFns } from "./vrBrainPonit.vue?vue&type=template&id=28a54d77&"
import script from "./vrBrainPonit.vue?vue&type=script&lang=js&"
export * from "./vrBrainPonit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports